<mat-toolbar *ngIf="authService.user !== undefined && apiService.hasEntitlement(authService.user!.entitlements, 'STAFF')">
  <span class="center-logo"><img class="toolbar-logo" src="assets/cubed_logo.png" alt="Cubed! Logo"></span>
  <a class="toolbar-user" routerLink="/players/{{authService.user!.uuid}}">
    <span class="toolbar-user-meta">
      <span class="toolbar-user-name">{{authService.user!.username}}</span>
      <span class="toolbar-user-rank" *ngIf="authService.user?.ranks!.length > 0">{{authService.user!.ranks[0]!.name}}</span>
    </span>
    <img class="toolbar-user-avatar" src="https://mc-heads.net/avatar/{{authService.user!.uuid}}/100" alt="User avatar">
  </a>
</mat-toolbar>
<mat-drawer-container>
  <mat-drawer mode="side" opened *ngIf="authService.user !== undefined && apiService.hasEntitlement(authService.user!.entitlements, 'STAFF')">
  <mat-nav-list>
      <span *ngFor="let category of nav">
        <h3 class="nav-header" matSubheader>{{category.name}}</h3>
      <mat-list-item routerLink="{{link.url}}" *ngFor="let link of category.items"
        [disabled]="link.permission !== undefined && !apiService.hasEntitlement(authService.user!.entitlements, link.permission!)">
        <mat-icon style="margin-right: 20px;" matListItemIcon>{{link.icon}}</mat-icon>
        {{link.name}}
      </mat-list-item>
        <mat-divider></mat-divider>
        </span>
    </mat-nav-list>
  </mat-drawer>
  <mat-drawer-content style="height: 93vh;">
    <div class="layout-content-container">
      <router-outlet></router-outlet>
    </div>
  </mat-drawer-content>
</mat-drawer-container>
